import { NotificationType } from "@next-platform/client-common-core";
import type { TFunction } from "i18next";

type GetDefaultNotificationMessageOptions = {
  type: NotificationType;
  t: TFunction;
};

export const getDefaultNotificationMessage = ({ type, t }: GetDefaultNotificationMessageOptions): string => {
  const defaultNotificationMessages: Record<NotificationType, string> = {
    [NotificationType.default]: t("common:toast.success"),
    [NotificationType.success]: t("common:toast.success"),
    [NotificationType.error]: t("common:toast.somethingWentWrong"),
    [NotificationType.info]: t("common:toast.alert"),
    [NotificationType.alert]: t("common:toast.alert"),
    [NotificationType.warning]: t("common:toast.alert"),
  };

  return defaultNotificationMessages[type];
};

// eslint-disable-next-line id-length -- keep "t" as the standard i18n translation helper for readability and tooling support
export const getOfflineNotificationMessage = (t: TFunction): string => {
  return t("common:toast.networkUnavailable");
};
